import React from 'react';
import styled from 'styled-components';

const FullLayoutDiv = styled.div`
  width: 100%;
  ${(props) => props.outerStyles}
`;

export default ({ children, outerStyles }) => (
  <FullLayoutDiv outerStyles={outerStyles}>
    { children }
  </FullLayoutDiv>
);
